import { initI18n } from './init-i18n';
import { configureDateFnsForEnglish } from './configure-date-fns-for-english';
import { configureDateFnsOnLanguageChange } from './configure-date-fns-on-language-change';
import { configureMomentForEnglish } from './configure-moment-for-english';
import { configureMomentOnLanguageChange } from './configure-moment-on-language-change';
import { configureT } from './configure-t';

export const initialize = () => {
	configureMomentOnLanguageChange();
	configureDateFnsOnLanguageChange();

	initI18n();
	configureT();
	configureMomentForEnglish();
	configureDateFnsForEnglish();
};
